import type { RosterItemResponseOrganizationRosterResponseRelatedPagedData } from '@on3/api';
import { adjustColorForReadability } from '@on3/ui-lib/utils/accessibility/color';
import { slugify } from '@on3/ui-lib/utils/slugify';
import { highSchoolHeaderListSelection } from '@public/components/HighSchool/Roster/HighSchoolRosterHeader';
import { HighSchoolRosterItem } from '@public/components/HighSchool/Roster/HighSchoolRosterItem';
import { TextLink } from '@public/components/UI/Link/TextLink';
import { RosterWrapper } from '@public/hocs/Roster/RosterWrapper';
import { useRouter } from 'next/router';

import styles from './RosterModule.module.scss';

interface IHighSchoolRosterProps {
  currentAthletes: RosterItemResponseOrganizationRosterResponseRelatedPagedData;
}
export const RosterModule = ({ currentAthletes }: IHighSchoolRosterProps) => {
  const { relatedModel, list } = currentAthletes ?? {};
  const { orgResponse } = relatedModel || {};
  const primaryColor = adjustColorForReadability(
    orgResponse?.primaryColor || '#fe3b1f',
  );

  const router = useRouter();
  const slug = router.query.id as string;
  const sluggedSport = slugify(relatedModel?.sport?.name || 'football');

  const showList = !!list?.length;
  const viewAllRoute = `/high-school/${slug}/${sluggedSport}/roster/`;

  return (
    <section className={styles.block}>
      <h2>Roster</h2>
      {showList && (
        <>
          <div className={styles.headerListContainer}>
            {highSchoolHeaderListSelection.map((item) => {
              return <span key={item.key}>{item.displayName}</span>;
            })}
          </div>
          <RosterWrapper roster={list}>
            {({ edit }) => (
              <ul className={styles.list}>
                {list?.slice(0, 5).map((item, index) => {
                  return (
                    <HighSchoolRosterItem
                      handleEdit={edit}
                      key={item.psoKey}
                      rosterItem={item}
                      sport={relatedModel?.sport?.name || 'football'}
                    />
                  );
                })}
              </ul>
            )}
          </RosterWrapper>
          <div className={styles.viewAllContainer}>
            <TextLink href={viewAllRoute} style={{ color: primaryColor }}>
              View Full {relatedModel?.sport?.name} Roster
            </TextLink>
          </div>
        </>
      )}
      {!showList && <span>There are no players on this roster.</span>}
    </section>
  );
};
